import { Component } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { Slide } from './../../models/slides/slides.model';
import { File } from './../../models/files/files.model';

import * as appConfig from './../../app.config';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-slide-list',
  templateUrl: './slide-list.component.html',
})
export class SlideListComponent extends ListBase<Slide> {
  public url = 'slides';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    )
  }

  public getFileStyle(file: File): any {
    if (null !== file && file.is_image) {
      if (file.is_resizable) {
        return {
          'background-image':
            'url(' +
            appConfig.apiUrl +
            appConfig.mediaFolder +
            '800x800_' +
            file.file_fullname +
            ')'
        };
      }
      return {
        'background-image':
          'url(' +
          appConfig.apiUrl +
          appConfig.mediaFolder +
          file.file_fullname +
          ')'
      };
    }

    return {};
  }

  public getClaim(data: any): string {
    let claim = '';
    if (data) {
      claim = data['claim_' + appConfig.languages[0]];
    }
    return claim;
  }

  public getSubClaim(data: any): string {
    let subclaim = '';
    if (data) {
      subclaim = data['subclaim_' + appConfig.languages[0]];
    }
    return subclaim;
  }

}
